import type { ComponentNode } from '../../../store/checkoutBuilder/types';
import CheckoutImage from '../checkout-components/CheckoutImage';

type Props = {
  node: ComponentNode;
  selected: boolean;
  onSelect: () => void;
  onUpdateProps: (patch: Record<string, any>) => void;
  dragHandleProps?: any;
  onDelete?: () => void;
  onDuplicate?: () => void;
};

export default function ImageAdapter({ node, selected, onSelect, onUpdateProps, dragHandleProps, onDelete, onDuplicate }: Props) {
  const cfg = node.props || {};
  return (
    <CheckoutImage
      selected={selected}
      zone="side"
      config={{
        imageUrl: cfg.src || cfg.imageUrl,
        align: cfg.align || 'center',
        background: cfg.background || '#f4f8fe',
        borderColor: cfg.borderColor || '#b3d1fa',
        borderWidth: cfg.borderWidth ?? 1,
        radius: cfg.radius ?? 8,
        href: cfg.href,
        alt: cfg.alt,
      }}
      onSelect={onSelect}
      onConfigChange={(patch) => {
        const mapped: Record<string, any> = { ...patch };
        if ('imageUrl' in mapped) {
          mapped.src = mapped.imageUrl;
          delete mapped.imageUrl;
        }
        onUpdateProps(mapped);
      }}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      dragHandleProps={dragHandleProps}
    />
  );
}
